import Auth from "components/Auth/Auth";

const LoginScreen = () => {
    return <Auth />;
};

export default LoginScreen;
